import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';

type Props = {
  title: string;
  lead?: string;
  type?: 'h1' | 'h2' | 'h3';
  id?: string;
};

const SimpleHeader = ({ title, lead, type = `h1`, id }: Props) => (
  <Box
    id={id}
    as="section"
    maxW="4xl"
    mx="auto"
    px={[8, null, 0]}
    py={36}
    textAlign={[`start`, null, `center`]}
    whiteSpace="pre-line"
  >
    <Heading as={type} size="3xl" pe={[6, null, 0]}>
      {title}
    </Heading>
    {lead && (
      <Text px={[null, null, null, 24]} fontSize={[`md`, null, `lg`]} mt={6}>
        {lead}
      </Text>
    )}
  </Box>
);

export default SimpleHeader;
